(() => {
  const panelSelector = '[data-bp-refraction]';
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cleanups = new WeakMap();

  const resetRefraction = (panel) => {
    panel.style.setProperty('--bp-refraction-x', '50%');
    panel.style.setProperty('--bp-refraction-y', '18%');
  };

  const initializePanel = (panel) => {
    if (cleanups.has(panel) || !finePointer.matches || reducedMotion.matches) return;

    const handlePointerMove = (event) => {
      const bounds = panel.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;

      const x = ((event.clientX - bounds.left) / bounds.width) * 100;
      const y = ((event.clientY - bounds.top) / bounds.height) * 100;
      panel.style.setProperty('--bp-refraction-x', `${Math.min(100, Math.max(0, x))}%`);
      panel.style.setProperty('--bp-refraction-y', `${Math.min(100, Math.max(0, y))}%`);
    };

    const handlePointerLeave = () => resetRefraction(panel);

    panel.addEventListener('pointermove', handlePointerMove, { passive: true });
    panel.addEventListener('pointerleave', handlePointerLeave);
    panel.dataset.bpRefractionReady = 'true';

    cleanups.set(panel, () => {
      panel.removeEventListener('pointermove', handlePointerMove);
      panel.removeEventListener('pointerleave', handlePointerLeave);
      delete panel.dataset.bpRefractionReady;
      resetRefraction(panel);
      cleanups.delete(panel);
    });
  };

  const findPanels = (root) => {
    const panels = [];
    if (root instanceof Element && root.matches(panelSelector)) panels.push(root);
    if (root.querySelectorAll) panels.push(...root.querySelectorAll(panelSelector));
    return panels;
  };

  const initialize = (root = document) => {
    findPanels(root).forEach(initializePanel);
  };

  const destroy = (root) => {
    findPanels(root).forEach((panel) => cleanups.get(panel)?.());
  };

  const refreshPointerMode = () => {
    document.querySelectorAll(panelSelector).forEach((panel) => cleanups.get(panel)?.());
    initialize(document);
  };

  document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  finePointer.addEventListener('change', refreshPointerMode);
  reducedMotion.addEventListener('change', refreshPointerMode);

  window.BPUniverse = Object.freeze({ initialize, destroy });
})();
